import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { TemplateRefBulletinService } from './template-ref-bulletin.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.scss'],
})
export class BulletinComponent implements OnInit {
  @ViewChild('bulletinForm', { static: true }) bulletinForm: TemplateRef<any>;

  article = null;
  imgUrl = environment.ImageUrl;


  carouselOptions: any = {
    grid: {
      rows: 3,
      fill: 'row',
    },
    // loop: true,
    // nav: true,
    // navText: [
    //   '<i class="fas fa-chevron-left"></i>',
    //   '<i class="fas fa-chevron-right"></i>',
    // ],
    // // dots: true,
    // responsive: {
    //   0: {
    //     items: 1
    //   },
    // }
  };
  bulletin: any = {
    text: '',
    hasSubmit: false,
    bulletinLikes: [],
  };
  bulletins: any = [];
  isLogin: any = 0;
  isLoading: boolean = false;
  appUserId: any;

  constructor(
    private sharedService: SharedService,
    private auth: AuthServiceService,
    private route: ActivatedRoute,
    private location: Location,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private templateRefService: TemplateRefBulletinService,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.templateRefService.setBulletinPopup(this.bulletinForm);

    this.initBulletin();
    // this.route.paramMap.subscribe(params => {
    //   this.auth.get_bottom_banner_by_slug(params.get('slug')).subscribe((response: any) => {

    //     this.article = response.body
    //     this.title.setTitle(`${response.body.title} | KACHIING`);
    //     this.meta.addTags([
    //       { name: 'description', content: 'Home page of SEO friendly app' },
    //       { name: 'author', content: response.body.author },
    //       { name: 'keywords', content: `${response.body.category}, ${response.body.memberShopSubRegion}, ${response.body.memberShopCategory} ` }
    //     ]);
    //   }, (e) => {
    //     // this.toastr.error(e.error.message);
    //   });
    // });
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.appUserId = user.id;
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
    });
  }

  goBack() {
    this.commonService.goBack();
  }

  convertDate(value: number) {
    let date = value;

    return moment.unix(value).format('MMMM D, YYYY');
  }

  initBulletin(page: number = 1) {
    this.isLoading = true;
    this.auth.bulletin_fetch().subscribe((response: any) => {
      const result = response.body;
      this.bulletins.list = result.data;
      this.bulletins.currentPage = result.currentPage;
      this.bulletins.lastPage = result.lastPage;
      this.bulletins.list.map((row: any) => {
        // row.user = row.user ?? {}
        row.createdAt = this.convertDate(row.createdAt);
      });

      this.isLoading = false;
    });
  }

  hasCheckedBulletin(data: any) {
    return data.filter((row: any) => row.userId == this.appUserId).length > 0;
  }

  handleLike(bulletinId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    const payload = {
      userId: this.appUserId,
      bulletinId: bulletinId,
    };

    if (this.hasCheckedBulletin(data.bulletinLikes))
      data.bulletinLikes = data.bulletinLikes.filter(
        (row: any) => row.userId != this.appUserId
      );
    else data.bulletinLikes = [...data.bulletinLikes, payload];

    this.auth.bulletin_likes(payload).subscribe();
  }

  onEditorChange = (event: any) =>
    (this.bulletin.text = event.editor.getData());

  bulletinStore(id?: number) {
    if (this.bulletin.text.length < 1 && id == null) {
      return this.toastr.error('Please Fill a Message !');
    }

    const formData = {
      shopId: 0,
      text: this.bulletin.text,
      id: this.bulletin.id,
      // uuid: this.local.generateUUID(),
    };

    this.bulletin.hasSubmit = true;

    try {
      this.auth.bulletin_store(formData).subscribe(
        (response: any) => {
          this.toastr.success('The bulletin was successfully added');
          this.bulletin.hasSubmit = false;
          this.initBulletin();
          this.bulletin.text = '';
          this.modalService.dismissAll();
        },
        (e) => {
          this.toastr.error(e.error?.message ?? 'Internal Server Error');
          this.bulletin.hasSubmit = false;
        }
      );
    } catch (e) {
      this.bulletin.hasSubmit = false;
    }
  }
}
